export default function SuccessToastIcon() {
	return (
		// biome-ignore lint/a11y/noSvgWithoutTitle: <explanation>
		<svg
			width="60"
			height="61"
			viewBox="0 0 60 61"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="30.0517"
				cy="30.145"
				r="27.7041"
				fill="#27D280"
				fill-opacity="0.16"
			/>
			<circle
				cx="30.0518"
				cy="30.145"
				r="22.0693"
				fill="#27D280"
				fill-opacity="0.2"
			/>
			<circle cx="30.0515" cy="30.145" r="14.5564" fill="#27D280" />
			<path
				d="M35.625 26.8118L27.8906 33.843L24.375 30.647"
				stroke="white"
				stroke-width="2.43584"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	);
}
